<template>
	<v-dialog v-model="dialog" persistent max-width="600px" hide-overlay>
		<template v-slot:activator="{ on }">
			<v-btn color="secondary" class="text-lowercase" icon v-on="on">
			<v-tooltip bottom color="primary">
				<template v-slot:activator="{ on }">
					<v-icon small v-on="on">mdi-lead-pencil</v-icon>
				</template>
				<span>{{'add' | localize }}/{{'modify sales' | localize }}</span>
			</v-tooltip>
			</v-btn>
		</template>
		<v-card v-show="!loading">
			<v-spacer></v-spacer>
			<v-card-title class="subtitle-1 pt-6 text-pre-wrap">
				{{ 'Add sales of the' | localize }} <span class="secondary--text"> {{ product.trademark.name }} {{ product.model }}</span>	
			</v-card-title>
			<v-divider />
			<v-card-text class="black--text">
				<v-container grid-list-md>
				<v-form ref="form" v-model="valid" lazy-validation>
					<v-row>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="secondary"
								:label="'Unit cost' | localize"
								v-model.number="unit_cost"
								prefix="$"
								name="unit_cost"
								type="text"
								readonly>
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="secondary"
								:label="'Sales plan' | localize"
								v-model.number="sales_plan"
								:suffix="'units' | localize"
								name="salesPlan"
								type="text"
								:rules="[rules.number]"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense dirty
								color="secondary"
								:label="'Production plan' | localize"
								v-model.number="production_plan"
								:suffix="'units' | localize"
								:hint="hint"
								persistent-hint
								name="productionPlan"
								type="text"
								:rules="[rules.number_hint]"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="secondary"
								:label="'Retail price' | localize"
								v-model.number="retail_price"
								prefix="$"
								name="retailPrice"
								type="text"
								:rules="[rules.number]"
								@change="onceMore()">
							</v-text-field>
						</v-col>
						<v-col cols="12" sm="6" md="4">
							<v-text-field dense
								color="secondary"
								:label="'Ex-works price' | localize"
								v-model.number="price"
								prefix="$"
								name="price"
								type="text"
								:rules="[rules.number]"
								@change="onceMore()">
							</v-text-field>
						</v-col>
					</v-row>
				</v-form>
				</v-container>
				<v-row v-if="error" justify="center" class="mx-2 error--text">{{'Error' | localize }} =>  {{ error }} &#128533;</v-row>
			</v-card-text>
			<v-divider />
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="secondary" text
					class="text-capitalize"
					:disabled="loading || !valid || Boolean(error)"
					@click="changeModel">
					{{'Save' | localize}}
				</v-btn>
				<v-btn color="secondary" text class="text-capitalize" @click="closeDialog">
					{{'Close' | localize}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import localizeFilter from '../../../filters/localize.filter';
import { localeNumber } from '../../../functions/common';

	export default {
		props: ['product'],
		data () {
			return	{
				dialog: false,
				valid: false,
				error: '',
				rules: {
					number: v => {
						if (!isNaN(parseFloat(v)) && v >= 0) return true;
						return localizeFilter('its expected number more than 0');
					},
					number_hint: v => {
						if (v <= this.production_plan_hint) return true;
						return (localizeFilter('its expected number between 0 and') + ` ${this.production_plan_hint}`);
					}
				},			
				id: this.product.id,
				unit_cost: this.product.unit_cost,
				sales_plan: this.product.sales_plan,
				production_plan: this.product.production_plan,
				retail_price: this.product.retail_price,
				price: this.product.price,
				
			}
		},
		computed: {
			loading () {
				return this.$store.getters.loading
			},
			locale() {
				return this.$store.getters.locale;
			},
			products() {
				return this.$store.getters.products;
			},
			resources() {
				return this.$store.getters.resources_team;
			},
			production_plan_hint() {
				let all_production  = 0;
				let capacities = 0;
					
				if (this.products?.length > 0 && this.resources?.length > 0) {
					this.products.forEach((prod) => {
						if (prod.productId !== this.product.productId) {
							all_production += prod.production_plan;
						}
					});
						
					capacities = this.resources[0].capacities
				}
				const res = (capacities - all_production >= 0) ? capacities - all_production : 0;
				return  res;
			},
			hint() {
				return (localizeFilter('not more than') + ` ${this.formatNumber(this.production_plan_hint)} `+ localizeFilter('units'))
			}
		},
		methods: {
			formatNumber(number) {
				return localeNumber(number, this.locale);
			},
			onceMore () {
				this.error = ''
			},
			async changeModel () {
				if (this.$refs.form.validate()) {
					
					if (this.sales_plan == this.product.sales_plan && 
						this.production_plan == this.product.production_plan &&
						this.retail_price == this.product.retail_price && 
						this.price == this.product.price) {

						return this.error = localizeFilter('no parameters have been changed'); 
					}
					else {
						/* edit old model */ 
						const upgraded = {
							id: this.product.id,
							trademark: this.product.trademark,
							model: this.product.model,
							team: this.product.team,
							sales_plan: this.sales_plan,
							production_plan: this.production_plan,
							retail_price: this.retail_price,
							price: this.price,	
						}
						/*console.log(upgraded)*/
						try {
							await this.$store.dispatch('editTeamProduct', upgraded);
						}
						catch (error) {
							await this.$store.dispatch('setError', error.message)
						}
						this.closeDialog();
					}
				}
			},
			closeDialog () {
				//reset
				this.dialog = false
				this.error = ''	
			}
		},
		async created() {
			if (this.resources == null) {

				const params = {
					gameId: this.product.gameId,
					round: this.product.round,
					teamId: this.product.teamId,
				}

				try {
					await this.$store.dispatch('fetchTeamResources', params);
				} catch (error) {
					await this.$store.dispatch('setError', error.message)
				}
			}
		}
	}
</script>

